<div class="container-fluid p-0">
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <span class="navbar-brand">Asset Register</span>
    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      aria-expanded="false"
      aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <span class="mr-auto">
        <button
          mat-raised-button
          color="primary"
          (click)="onAdd()"
          id="add"
          class="m-1 mr-2">
          <mat-icon>add</mat-icon>
          Add Asset
        </button>

        <button mat-raised-button class="m-1 mr-2" routerLink="/asset-register/importer" matTooltip="Click this button to mass import Assets from a CSV file.">
          <mat-icon>cloud_upload</mat-icon> Import
        </button>

        <mat-menu #appMenu="matMenu">
          <button mat-menu-item (click)="dataSource.selectAllToggle()">
            <mat-icon *ngIf="dataSource.isAllSelected()"> clear_all</mat-icon><mat-icon *ngIf="!dataSource.isAllSelected()">select_all</mat-icon>
            {{ dataSource.isAllSelected() ? 'Deselect' : 'Select' }} All
          </button>

          <button *ngIf="dataSource.filters.archived == 'false'" mat-menu-item (click)="onRemoveSelected()" [disabled]="!dataSource.selection.hasValue()">
            <mat-icon>archive</mat-icon> Archive Selected
          </button>

          <button *ngIf="dataSource.filters.archived == 'false'" mat-menu-item (click)="onExportSelected('pdf')">
            <mat-icon>cloud_download</mat-icon> Export {{ dataSource.selection.hasValue() ? '(' + dataSource.selection.selected.length + ') Selected' : 'All' }} to PDF
          </button>
          <button *ngIf="dataSource.filters.archived == 'false'" mat-menu-item (click)="onExportSelected('csv')">
            <mat-icon>cloud_download</mat-icon> Export {{ dataSource.selection.hasValue() ? '(' + dataSource.selection.selected.length + ') Selected' : 'All' }} to CSV
          </button>
          <button *ngIf="dataSource.filters.archived == 'false'" mat-menu-item (click)="onExportSelected('xlsx')">
            <mat-icon>cloud_download</mat-icon> Export {{ dataSource.selection.hasValue() ? '(' + dataSource.selection.selected.length + ') Selected' : 'All' }} to XLSX
          </button>

          <button *ngIf="dataSource.filters.archived == 'true'" mat-menu-item (click)="onRestoreSelected()" [disabled]="!dataSource.selection.hasValue()">
            <mat-icon>restore</mat-icon> Restore Selected
          </button>
        </mat-menu>

        <button *ngIf="dataSource.filters.archived == 'false'" mat-button class="m-1 mr-2" [matMenuTriggerFor]="appMenu" matTooltip="Use this menu to select/deselect and/or export Asset." style="min-width: 150px">
          <mat-icon>more_vert</mat-icon>
          List Menu/Export
        </button>
        <button *ngIf="dataSource.filters.archived == 'true'" mat-button class="m-1 mr-2" [matMenuTriggerFor]="appMenu" matTooltip="Use this menu to select/deselect Asset." style="min-width: 120px">
          <mat-icon>more_vert</mat-icon>
          List Menu
        </button>
      </span>

      <button mat-raised-button class="m-1 mr-lg-3" (click)="onFilter()" matTooltip="Click this button to display filter options.">
        <mat-icon>filter_list</mat-icon> Filter
      </button>

      <form class="form-inline mx-1 my-0" (ngSubmit)="dataSource.getData(true)">
        <input
          class="form-control ml-0 mr-2 my-1"
          type="search"
          [(ngModel)]="dataSource.search"
          name="search"
          placeholder="Search"
          aria-label="Search"
          matTooltip="Search for Assets" />

        <button
          mat-raised-button
          color="secondary"
          type="submit"
          class="mx-0 my-1"
          matTooltip="Run the current search">
          <mat-icon>search</mat-icon> Search
        </button>
      </form>
    </div>
  </nav>

  <app-tags-filter (tagsFilterOutput)="getOutputTagsFilter($event)"></app-tags-filter>

  <div class="mat-elevation-z8 scroll-box">
    <table mat-table [dataSource]="dataSource" style="width: 100%" matSort matSortActive="id" matSortDirection="asc" matSortDisableClear>
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef [style.width.px]="65">
          <mat-checkbox
            (change)="$event ? dataSource.selectAllToggle() : null"
            [checked]="dataSource.selection.hasValue() && dataSource.isAllSelected()"
            [indeterminate]="dataSource.selection.hasValue() && !dataSource.isAllSelected()">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="$event ? dataSource.selection.toggle(row.id) : null"
            [checked]="dataSource.selection.isSelected(row.id)">
          </mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="id">
        <th mat-header-cell mat-sort-header *matHeaderCellDef matTooltip="Toggle sorting by the id of the asset.">
          #
        </th>
        <td mat-cell *matCellDef="let asset">
          {{ asset.id }}
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header matTooltip="Toggle sorting by the name of the asset." [style.width.px]="250">
          Name
        </th>
        <td mat-cell *matCellDef="let asset" class="no-padding text-wrap">
          {{ asset.name  }}
        </td>
      </ng-container>

      <ng-container matColumnDef="code">
        <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header matTooltip="Toggle sorting by the code of the asset.">
          Code
        </th>
        <td mat-cell *matCellDef="let asset" class="no-padding text-wrap">
          {{ asset.code  }}
        </td>
      </ng-container>

      <ng-container matColumnDef="asset_type">
        <th mat-header-cell *matHeaderCellDef class="no-padding" [style.width.px]="280">
          Type
        </th>
        <td mat-cell *matCellDef="let asset" class="no-padding text-wrap">
          <ng-container *ngIf="asset.asset_type?.parent">
            <small style="display: block;">
              {{ (asset.asset_type?.parent?.name | ellipsis: ['30']) || '' }}
            </small>
          </ng-container>
          <mat-icon *ngIf="asset.asset_type?.parent_id" style="font-size: 16px;">subdirectory_arrow_right</mat-icon>
          {{ (asset.asset_type?.name | ellipsis: ['30'])  || '' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="flags">
        <th mat-header-cell *matHeaderCellDef class="no-padding" [style.width.px]="130">
          Flags
        </th>
        <td mat-cell *matCellDef="let asset" class="no-padding text-wrap">
          <mat-icon *ngIf="asset.is_visible" matTooltip="Visible on Mobile app." class="visible-yes">visibility</mat-icon>
          <mat-icon *ngIf="asset.is_mobile" matTooltip="Movable Asset." class="mobile-yes">directions_car</mat-icon>
          <mat-icon *ngIf="asset.is_safety_critical" matTooltip="Safety Critical." class="safety-critical-yes">warning</mat-icon>
          <!-- Maintenance Records -->
          <mat-icon
            *ngIf="asset.enable_maintenance_records && asset.maintenance_record_due_at"
            [matTooltip]="assetsService.getMaintenanceRecordDueTooltip(asset.maintenance_record_due_at)"
            [ngClass]="assetsService.getMaintenanceRecordDueClass(asset.maintenance_record_due_at)">
            handyman
          </mat-icon>
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef class="no-padding">
          Status
        </th>
        <td mat-cell *matCellDef="let asset" class="no-padding text-wrap">
          <span [style.color]="assetsService.getStatusColor(asset.status) || null">
            {{ assetsService.getStatusLabel(asset.status) }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="owner_type">
        <th mat-header-cell *matHeaderCellDef class="no-padding">
          Owner Type
        </th>
        <td mat-cell *matCellDef="let asset" class="no-padding text-wrap">
          {{ assetsService.getOwnerTypeLabel(asset.owner_type) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="maintenance_due_date">
        <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header matTooltip="Toggle sorting by the maintenance due date of the asset.">
          Maintenance Due Date
        </th>
        <td mat-cell *matCellDef="let asset" class="no-padding text-wrap">
          <span [style.color]="utils.getDueDateColor(asset.maintenance_due_date) || null">
            {{ asset.maintenance_due_date ? (asset.maintenance_due_date | timezoneConvertMedium) : '' }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="next_inspection_due_date">
        <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header matTooltip="Toggle sorting by the inspection due date of the asset.">
          Inspection Due Date
        </th>
        <td mat-cell *matCellDef="let asset" class="no-padding text-wrap">
          <span [style.color]="utils.getDueDateColor(asset.next_inspection_due_date) || null">
            {{ asset.next_inspection_due_date ? (asset.next_inspection_due_date | timezoneConvertMedium) : '' }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="condition_rating">
        <th mat-header-cell *matHeaderCellDef class="no-padding">
          Condition Rating
        </th>
        <td mat-cell *matCellDef="let asset" class="no-padding text-wrap">
          <span [style.color]="assetsService.getConditionColor(asset.condition_rating) || null">
            {{ assetsService.getConditionLabel(asset.condition_rating)  }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="site">
        <th mat-header-cell mat-sort-header *matHeaderCellDef matTooltip="Toggle sorting by the site name of the asset." [style.width.px]="280">
          {{ utils.getLangTerm('parent-child-sites-combined.singular', 'Site') }}
        </th>
        <td mat-cell *matCellDef="let asset" class="text-wrap">
          <ng-container *ngIf="asset.site">
            <ng-container *ngIf="asset?.site?.parent_site">
              <small style="display: block;">
                <a [routerLink]="utils.prepareSiteRelatedLink(asset?.site?.parent_site?.id, null, '/edit/details')">
                  {{ (asset?.site?.parent_site?.name | ellipsis: ['30']) || '' }}
                </a>
              </small>
            </ng-container>
            <mat-icon *ngIf="asset?.site?.parent_site_id" style="font-size: 16px;">subdirectory_arrow_right</mat-icon>
            <a [routerLink]="utils.prepareSiteRelatedLink(asset?.site?.id, asset?.site?.parent_site?.id, '/edit/details')">
              {{ (asset?.site?.name | ellipsis: ['30']) || '' }}
            </a>
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="buttons">
        <th mat-header-cell *matHeaderCellDef [style.width.px]="240"></th>
        <td mat-cell *matCellDef="let asset">
          <button *ngIf="dataSource.filters.archived == 'false'" type="button" mat-button (click)="onView(asset.id)">
            View
          </button>

          <button *ngIf="dataSource.filters.archived == 'false'" type="button" mat-button (click)="onEdit(asset)">
            Edit
          </button>

          <button *ngIf="dataSource.filters.archived == 'false'" type="button" mat-button (click)="onRemove(asset)">
            Archive
          </button>

          <button *ngIf="dataSource.filters.archived == 'true'" type="button" mat-button (click)="onRestore(asset.id)">
            Restore
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <mat-paginator
      [length]="dataSource?.total | async"
      [pageSize]="dataSource.limit"
      [pageSizeOptions]="dataSource.pageSizeOptions"
      showFirstLastButtons>
    </mat-paginator>
  </div>
</div>
